import { Box, Divider, LinearProgress } from '@mui/material';
import { MaintenanceBody, ToolsListing } from '../../components/custom';
import { LayoutBase } from '../../layouts';
import { useNavigate, useParams } from 'react-router-dom';
import { CustomAlert, VMenu } from '../../components/shared';
import { useEffect, useState } from 'react';
import { IMantenance, MaintenancesServices } from '../../services/api/maintenances/MaintenancesServices';
import { FormatedDate, helpers } from '../../services/helpers/helpers';


export const MaintenancePlanning = () => {
    
    const { id } = useParams();
    const navigate = useNavigate();
    const [ , setData ] = useState<IMantenance[]>([]);
    const [alertInfo, setAlertInfo] = useState<{ open: boolean; message: string; severity: 'success' | 'error' | 'warning' | 'info' }>({
        open: false,
        message: '',
        severity: 'success'
    });
    const [ formValues, setFormValues ] = useState<FormatedDate[]>();

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = () => {
        if(id){
            MaintenancesServices.list(id)
                .then((response) => {
                    if (response instanceof Error) {
                        setAlertInfo({
                            open: true, 
                            message: `Erro ao buscar registro. Erro: ${response.message}`, 
                            severity: 'error'
                        });
                    } else {
                        setData(response);
                        const resultados = helpers.processData(response);
                        setFormValues(resultados);
                    }
                })
                .catch((error) => {
                    setAlertInfo({
                        open: true, 
                        message: `Erro ao buscar registro. Erro: ${error.message}`, 
                        severity: 'error'
                    });
                });
            }
    };

    
    return(
        <LayoutBase
            title='Planejamento das manutenções'
            tollBar={
                <ToolsListing
                    onClickNew={() => navigate('./novo')}
                    showNewButton={true}
                />
            }
        >
            <Box>
                <VMenu id={id}/>
                <Divider/>
                {formValues == undefined ? <LinearProgress /> : 
                    <MaintenanceBody values={formValues}/>
                }
            </Box>
            {alertInfo.open &&
                <CustomAlert
                    severity={alertInfo.severity}
                    message={alertInfo.message}
                />
            }
        </LayoutBase>
    );
};